import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Select, TextField, Typography, Grid, FormControlLabel, Button} from "@mui/material";


export const InputField = styled("textarea")`
    color: black;
    border: 1px solid black;
    width: 80%;
`;

export const QuestionContainer = styled("div")`
    background: white;
    margin-top: 1em;
    border-radius: 1em;
    padding: 1em 2em 2em 2em;

`;
export const Question = styled("div")`
    font-weight: 600;
    padding-bottom: 1em;
`;
export const CommentsText = styled("div")`
    font-weight: 600;
    padding-bottom: .5em;
`;
export const RadioButtons = styled("div")`
    display: flex;
    height: 2em;
`;
export const WordLimit = styled("div")`
    padding: 0em 1em 1em 1em;
`;

export const ButtonOption = styled("div")`
    display: flex;
    padding-right: 2em;
`;

export const Sliders = styled("div")`
    display: flex;
    width: 30em;
    padding-left: 1em
`;

export const SliderContainer = styled("div")`
    width: 100%;
    display: inline-flex;
    padding-right: 1em;
`;

export const SliderValue = styled("div")`
    position: relative;
    top: .3em;
    left: 1em;
    background-color: lightgrey;
    height: 1.5em;
    padding: .1em;
    margin-right: .5em;
`;

export const RadioRow = styled("div")`
    display: flex;
`;


export const RadioLabel = styled("label")`
    position: relative;
    top: .3em;
    left: .5em;
`;

export const SliderLabel = styled("label")`
    position: relative;
    top: .3em;
    padding-right: 1em;
`;

